export default __webpack_public_path__ + "static/media/iconMinusWhite.645dd552.svg";